import { render, staticRenderFns } from "./editqz.vue?vue&type=template&id=126c444f&scoped=true&"
import script from "./editqz.vue?vue&type=script&lang=js&"
export * from "./editqz.vue?vue&type=script&lang=js&"
import style0 from "./editqz.vue?vue&type=style&index=0&id=126c444f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c444f",
  null
  
)

export default component.exports